import React from 'react';
import './Toggle.scss';

interface IProps {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

const Toggle: React.FC<IProps> = (props) => {
  return (
    <div className={props.disabled ? "Toggle disabled" : "Toggle"}>
      <label htmlFor={props.id} className="toggleSwitch">
        <input
          disabled={props.disabled}
          onChange={(e) => props.onChange(e.target.checked)}
          id={props.id}
          type="checkbox"
          checked={props.checked}
        />
        <span className="slider"></span>
      </label>
    </div>
  );
};

export default Toggle;

